import AxiosInterceptor from "api/interceptor";

const user = new AxiosInterceptor();

export default {
  find() {
    return user.get("/me");
  },
  update(inputs) {
    return user.put("/user/profile", {
      firstname: inputs.firstname,
      lastname: inputs.lastname,
      email: inputs.email,
      phone: inputs.phone,
      avatar: inputs.avatar,
      gender: inputs.gender,
      birthday: inputs.birthday,
      address: inputs.address,
      city: inputs.city,
      postal_code: inputs.postal_code,
    });
  },
  resetPassword(pass, id) {
    return user.post("/customer/" + id + "/reset-password", {
      password: pass,
    });
  },
};
